import { render, staticRenderFns } from "./teacherFile.vue?vue&type=template&id=c2576fd6&scoped=true"
import script from "./teacherFile.vue?vue&type=script&lang=js"
export * from "./teacherFile.vue?vue&type=script&lang=js"
import style0 from "./teacherFile.vue?vue&type=style&index=0&id=c2576fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2576fd6",
  null
  
)

export default component.exports